import RepositoryService from 'src/services/repository'

const resource = 'company/myCompany'

export default {
  get: async () => {
    const response = await RepositoryService.base.get(resource)
    return response?.data ?? response
  },
  patch: async ({ logo, ...data }) => {
    const formData = new FormData()
    Object.entries(data).forEach(([key, value]) => formData.append(key, value))

    if (logo && logo instanceof File) {
      formData.append('logo', logo)
    }

    const response = await RepositoryService.base.patch(`${resource}`, formData, {
      'content-type': 'multipart/form-data',
    })
    return response?.data ?? response
  },
  getTokensHistory: () => RepositoryService.crud.getList(`${resource}/tokensHistory`),
  getTokensDemandList: () => RepositoryService.crud.getList(`${resource}/myDemandsHistory`),
  getTokensDemand: id => RepositoryService.crud.get(`${resource}/myDemandsHistory`, id),
  patchTokensDemand: data => RepositoryService.crud.patch(`${resource}/myDemandsHistory`, data),
  getTrainedPlayerQtyByMonth: async () => {
    const response = await RepositoryService.base.get(`${resource}/trainedPlayerQtyByMonth`)
    return response?.data ?? response
  },
  sendAction: (name, payload) => RepositoryService.crud.post(`${resource}/${name}`, payload),
}
